import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { ObservationFormContext } from "../../hooks/ObservationFormContext";
import { AchievementConditionPropsShape } from "../../interfaces/componentTypes";

import { GoalFormDropdown } from "./GoalFormDropdown";

export const AchievementConditions: React.FC<AchievementConditionPropsShape> = ({
  handleSetCondition,
  measurementUnit,
  achievementTarget,
  approved,
}) => {
  const { DBObject, t } = useContext(TMDataContext);
  const { goalState } = useContext(ObservationFormContext);

  const updateDropdown = (e) => {
    handleSetCondition(e);
  };

  return (
    <div
      className="goal-boxed-input-area"
      style={{ display: `${approved ? "block" : "none"}` }}
    >
      <div className="goal-form-input-row">
        <label
          className="goal-input-area-title"
          htmlFor="goal-achievement-condition-dropdown"
        >
          {t("views.goals.headings.achievement")}
        </label>
        <span>
          {t(
            `views.goals.contexts.${goalState.type.handle}.achievement_status_start`
          )}
        </span>
        <GoalFormDropdown
          selection={DBObject}
          child={"AchievementCondition"}
          handleSelect={updateDropdown}
          selectedItem={goalState["achievementCondition"]}
          dropdownId="goal-achievement-condition-dropdown"
        />
        <span>
          {t(`views.goals.contexts.${goalState.type.handle}.status_end`)}
        </span>
        <span className="goal-bold-highlight">
          {achievementTarget}
          {measurementUnit}
        </span>
      </div>
    </div>
  );
};
